module.exports = __webpack_public_path__ + "static/images/dollar.befb84e00fa902854180acf2c85cc116.svg";